import Vue from 'vue';
import './styles/tailwind.css';
import './styles/var.scss';

import App from './App.vue';
import router from './router';
import store from './store';
/* eslint-disable */
import MTD from '@ss/mtd-vue';
/* eslint-disable */
import '@ss/mtd-vue/lib/theme2/index.css';
/* eslint-disable */
import '@/styles/index.scss';
/* eslint-disable */
import agiEvalPlugin from '@/components/message/agiEvalPlugin';
import trackDirective from '@/directive/trackDirective';
/* eslint-disable */
import agiScroll from '@/directive/agiScroll';
Vue.use(MTD);
Vue.config.productionTip = false;
Vue.use(agiEvalPlugin);
Vue.directive('track', trackDirective);
Vue.directive('scroll', agiScroll);

const app_version = localStorage.getItem('app_version');
const currentVersion = (window as any).__current_version__;

if (Number(app_version) !== Number(currentVersion)) {
  localStorage.setItem('app_version', currentVersion);
  window.location.reload();
}

function preloadImages(imageUrls) {
  imageUrls.forEach(url => {
    const img = new Image();
    img.src = url;
  });
}
const imagesToPreload = [
  'https://p0.meituan.net/llmarena/2acbb094fd9132c268289eeba868e879785138.png',
  'https://p0.meituan.net/llmarena/9d9a77ca4e92c7155d8f59ee9c2ceedd851247.png',
  'https://p0.meituan.net/llmarena/f9a8d6a24c67939b223fb954bd0ffa761143020.png',
  'https://p0.meituan.net/llmarena/be7c691ff1de2c1cdc1a01d9cfe106b5675024.png',
  'https://p0.meituan.net/llmarena/eeb6004812459fe5304a3824ac199cb4775416.png',
  'https://p0.meituan.net/llmarena/77387d621406b375e482bf55a886d7411215263.png',
  'https://p0.meituan.net/llmarena/778440badd7e77e8bf6dbb86e90397ab4232472.png',
  'https://p0.meituan.net/llmarena/2ec58b8261872caac920ff102522cfcc524812.png',
];
preloadImages(imagesToPreload);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
